<template>
  <layout-main-inner title="购物送积分">
    <el-button
      slot="action"
      type="primary"
      @click="addIntrgral">新增购物积分</el-button>
    <layout-card-wrap>
      <el-table
        border
        :data="list">
        <el-table-column
          label="商品名称"
          prop="goodsName">
        </el-table-column>
        <el-table-column label="商品图片">
          <template slot-scope="scope">
            <el-image
              style="width: 128px; height: 128px"
              :src="scope.row.goodsSmallImage"
              fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="积分"
          width="100">
          <template slot-scope="{row, $index}">
            <span>{{ row.points }}积分</span>
            <el-popover
              :ref="`popover_${$index}`"
              style="margin-left:10px"
              trigger="click"
              placement="right"
              @show="() => {popoverShow(row, $index)}">
              <div style="margin:10px">
                <el-input-number
                  v-model="row.pointsBak"
                  controls-position="right"
                  :min="0"></el-input-number>
                <el-button
                  style="margin-left:10px"
                  type="primary"
                  @click="() => {updateSubmit(row,`popover_${$index}`)}">确定</el-button>
              </div>
              <i
                slot="reference"
                style="cursor: pointer;"
                class="el-icon-edit"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | dateformat("YYYY-MM-DD HH:mm") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="最近修改时间"
          width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.updatedTime | dateformat("YYYY-MM-DD HH:mm") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80">
          <template slot-scope="{row}">
            <el-switch
              :value="row.isopen"
              :active-value="1"
              :inactive-value="0"
              @change="updateStatus(row)">
            </el-switch>
            <!-- <el-button type="text"
              @click='deleteIntegral(row)'>删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
    <add-pay-product-modal
      ref="modal"
      :vendorId="userInfo.vendorId"
      :callback="fetchList" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import AddPayProductModal from './busi/add-pay-product-modal.vue'
export default {
  name: 'Sendpoints',
  components: { AddPayProductModal },
  data() {
    return {
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    popoverShow(row, $index) {
      row.pointsBak = row.points
      this.list.splice($index, 1, row)
    },
    addIntrgral() {
      this.$refs.modal.fetch()
    },
    updateStatus(row) {
      this.loading = true
      const dispatch = row.isopen === 1 ? 'closepayrule' : 'openpayrule'
      this.$store.dispatch(`integral/${dispatch}`, {
        payload: {
          ruleId: row.ruleId,
          vendorId: row.vendorId
        },
        success: () => {
          this.loading = false
          this.fetchList()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    updateSubmit(row, _ref) {
      this.loading = true
      this.$store.dispatch(`integral/updatepayrule`, {
        payload: {
          ruleId: row.ruleId,
          vendorId: row.vendorId,
          points: row.pointsBak,
          exchangeGoodsId: row.exchangeGoodsId,
          isopen: row.isopen
        },
        success: () => {
          this.loading = false
          // eslint-disable-next-line no-underscore-dangle
          this.$refs[_ref].doClose()
          this.fetchList()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteIntegral(row) {
      this.$confirm('您确定删除该购物商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('integral/delpayrule', {
            payload: {
              ruleId: row.ruleId,
              vendorId: row.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('integral/getpayrules', {
        payload: {
          ...this.config,
          vendorId: this.userInfo.vendorId
        },
        success: res => {
          this.loading = false
          this.list = res.data.records
          this.totalNum = res.data.total
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
